import React, { useState } from 'react';

import AreaList from '../area/AreaList';
import Col from 'react-bootstrap/Col';
import EditorSaveScheduleCancel from '../shared/buttons/EditorSaveScheduleCancel';
import Form from 'react-bootstrap/Form';
import formatter from '../../utilities/formatter';
import FormControl from '../shared/inputs/FormControl';
import PaymentDisplay from '../payment/PaymentDisplay';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import permissionsProvider from '../../utilities/permissionsProvider';

const EditForm = ({
    cancelEdit,
    fetchData,
    form: { item },
    form: { formChange },
    form: { reset },
    form: { setUrl },
    schedule,
    submitForm
}) => {
    const disabled = !permissionsProvider.canEdit(item.acl);
    const parentBaseUrl = '/api/jobs/edit/';

    return (
        <div>
            <div className="item-editor">
                <Row className="justify-content-end">
                    <Col xs="auto" className="fields-required-label" />
                </Row>
                <Form.Group as={Form.Row}>
                    <Form.Label as={Col} xs="auto">
                        Number
                    </Form.Label>
                    <Col>
                        <FormControl
                            type="number"
                            required
                            defaultValue={Number.isNaN(item.jobNumber) ? '' : item.jobNumber}
                            validationError={item.jobNumber_error}
                            name="jobNumber"
                            onChange={formChange}
                            placeholder="Job Number"
                            disabled={disabled} />
                    </Col>
                    <Form.Label as={Col} xs="auto" className="text-right">
                        <span style={{ fontWeight: '500' }}>Total: </span>{formatter.currency(item.total)}
                    </Form.Label>
                    <Form.Label as={Col} xs="auto" className="text-right">
                        <span style={{ fontWeight: '500' }}>Deposit: </span>{formatter.currency(item.depositAmount)}
                    </Form.Label>
                </Form.Group>
                <Form.Row className="py-2 px-3">
                    <Col>
                        <AreaList
                            formChange={formChange}
                            items={item.areas}
                            jobId={item.id}
                            disabled={disabled} />
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col sm={6}>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    name="paymentTerms"
                                    onChange={formChange}
                                    value={item.paymentTerms}
                                    validationError={item.paymentTerms_error}
                                    disabled={disabled}>
                                    <option value="1">No Terms</option>
                                    <option value="2">Net 10</option>
                                    <option value="3">Net 15</option>
                                    <option value="4">Net 30</option>
                                </SelectList>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    lookupType="JobStatus"
                                    name="jobStatusId"
                                    onChange={formChange}
                                    placeholder="Job Status"
                                    required={true}
                                    validationError={item.jobStatusId_error}
                                    value={item.jobStatusId}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    lookupType="Designer"
                                    name="designerId"
                                    onChange={formChange}
                                    placeholder="Designer"
                                    required={true}
                                    value={item.designerId}
                                    validationError={item.designerId_error}
                                    disabled={disabled}>
                                </SelectList>
                            </Form.Group>
                        </Form.Row>
                    </Col>
                    <Col sm={6}>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.addressLine1}
                                    name="addressLine1"
                                    onChange={formChange}
                                    placeholder="Address Line 1"
                                    required
                                    validationError={item.addressLine1_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.addressLine2}
                                    name="addressLine2"
                                    onChange={formChange}
                                    placeholder="Address Line 2"
                                    validationError={item.addressLine2_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md>
                                <FormControl
                                    required
                                    defaultValue={item.city}
                                    validationError={item.city_error}
                                    name="city"
                                    onChange={formChange}
                                    placeholder="City"
                                    disabled={disabled} />
                            </Form.Group>
                            <Form.Group as={Col} xs="auto" style={{ maxWidth: "75px" }}>
                                <SelectList
                                    required={true}
                                    placeholder="State"
                                    name="stateId"
                                    value={item.stateId}
                                    validationError={item.stateId_error}
                                    lookupType="State"
                                    onChange={formChange}
                                    disabled={disabled} />
                            </Form.Group>
                            <Form.Group as={Col} xs md={4}>
                                <FormControl
                                    defaultValue={item.zip}
                                    name="zip"
                                    onChange={formChange}
                                    placeholder="Zip"
                                    required
                                    validationError={item.zip_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={6}>
                        <FormControl as="textarea"
                            defaultValue={item.emailNote}
                            validationError={item.emailNote_error}
                            name="emailNote"
                            onChange={formChange}
                            rows="6"
                            placeholder="Email Notes"
                            disabled={disabled} />
                    </Form.Group>
                    <Form.Group as={Col} sm={6}>
                        <FormControl as="textarea"
                            className="form-control"
                            defaultValue={item.arNote}
                            name="arNote"
                            onChange={formChange}
                            placeholder="A/R Notes"
                            rows="6"
                            validationError={item.arNote_error}
                            disabled={disabled} />
                    </Form.Group>
                </Form.Row>
                <PaymentDisplay
                    parentId={item.id}
                    recordType='job'
                    customerId={item.customerId}
                    disabled={disabled}
                    saveParent={(callBack) => submitForm(callBack)}
                    resetParentForm={reset}
                    setParentUrl={setUrl}
                    parentBaseUrl={parentBaseUrl}
                    showDetail={true}
                />
            </div>
            <EditorSaveScheduleCancel
                reschedule={item.appointmentDate}
                scheduleAction={() => submitForm(schedule)}
                save={item.appointmentDate ? submitForm : () => submitForm(schedule)}
                cancel={cancelEdit}
                acl={item.acl}
                appointmentId={item.appointmentId}
                appointmentType={2} />
        </div >
    );
}

export default EditForm;